import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../../CrudForm/enums/FormMode'
import { useCrudFormStore } from '../../../CrudForm/Store/hooks/useStore'

import { EditButtonProps } from './interface'

export const EditButton = (props: EditButtonProps) => {
  const { mode, setMode } = useCrudFormStore(state =>
    pick(state, ['mode', 'setMode'])
  )

  const text = mode === FormMode.READ ? '编辑' : '取消'

  const handleClick = () => {
    setMode(mode === FormMode.READ ? FormMode.UPDATE : FormMode.READ)
  }

  return mode === FormMode.READ ? (
    <ActionButton ghost type='primary' {...props} onClick={handleClick}>
      {text}
    </ActionButton>
  ) : null
}
